import React from "react";
import MDBox from "../MD/MDBox";
import MDTypography from "../MD/MDTypography";


function SectionTitle({title}){
  return (
<MDBox
  mb={4}
  py={1.5}
  px={2}
  borderRadius="lg"
  textAlign="center"
  sx={({ palette: { brand } }) => ({ backgroundColor: brand.main })}
>
  <MDTypography component="h2" variant="h5" fontWeight="regular" color="white">
   {title}
  </MDTypography>
</MDBox>

  );
}
export default SectionTitle;